import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { productGroupStatusChangeChart } from 'src/store/slices/generalMonitoringSlice';
import { BarList, ChartSkeleton, MonitorCard, formatNumber } from 'src/components/monitoring/MonitoringParts';

// Ana ürün grubuna göre açık değişimler
function ProductGroupStatusChangeChart() {
  const dispatch = useDispatch();
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    dispatch(productGroupStatusChangeChart())
      .then((response) => {
        setData(Array.isArray(response.payload) ? response.payload : []);
        setLoading(false);
      })
      .catch(() => setLoading(false));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const items = data.map((i) => ({ label: i.ANA_GRUP, value: i.ADET }));
  const total = items.reduce((s, i) => s + (Number(i.value) || 0), 0);

  return (
    <MonitorCard
      title="Ürün Grubu Bazında Açık Değişimler"
      subtitle={loading ? 'Yükleniyor…' : `${items.length} ürün grubu · toplam ${formatNumber(total)} değişim`}
    >
      {loading ? <ChartSkeleton height={240} /> : <BarList items={items} maxHeight={300} />}
    </MonitorCard>
  );
}

export default ProductGroupStatusChangeChart;
